import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { selectIsLoggedIn } from "../../Store/api/auth/authSelectors";
import {
  getCurrentUrlWithoutPath,
  getLoginEndPoint,
  getLogoutEndPoint,
} from "../../ServiceUtils/auth";
import { useUnsavedChanges } from "../../MPP-Common-SPA/common/unsavedChangesContext";
import { URL_SEARCH_PARAMS } from "../../MPP-Common-SPA/common/constants/urlParams";
import { HINT_VALUES } from "../../MPP-Common-SPA/common/constants/values";

export const Relogin = () => {
  const [params] = useSearchParams();
  const hint = params.get(URL_SEARCH_PARAMS.Hint); 

  const isLoggedIn = useSelector(selectIsLoggedIn);
  const { clearDirty } = useUnsavedChanges();

  if (hint === HINT_VALUES.Logout && isLoggedIn) {
    document.location.href = getLogoutEndPoint(
        `${getCurrentUrlWithoutPath()}/login`,
    );
  }

  if (hint === HINT_VALUES.Login) {
    if (!isLoggedIn) {
      clearDirty();
      setTimeout(() => {
        window.location.href = getLoginEndPoint(`${getCurrentUrlWithoutPath()}/login`);
      }, 0);
    } else {
      document.location.href = "/apply";
    }
  }

  return (
    <div>
      <h1>Redirecting...</h1>
    </div>
  );
};
